import { render, staticRenderFns } from "./VehicleStatusOnRoute.vue?vue&type=template&id=6e1f6d70&scoped=true"
import script from "./VehicleStatusOnRoute.vue?vue&type=script&lang=js"
export * from "./VehicleStatusOnRoute.vue?vue&type=script&lang=js"
import style0 from "./VehicleStatusOnRoute.vue?vue&type=style&index=0&id=6e1f6d70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1f6d70",
  null
  
)

export default component.exports